import moment from 'moment'
import { DATE_FORMAT, STORAGE_TYPE_LOCAL } from '../config'
import StorageProviderFactory from '../managers/storage_provider_factory'

/**
 * this function takes none-standard time format as YYYY-MM-DDThh:mm:ss.xxxxxxZ
 * and return time string in app standard format
 * @param timeStr
 * @param format
 * @return {string}
 */
export const formatTimeString = (timeStr, format = DATE_FORMAT) => {
  const localTime = StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem('localTime') === 'true'
  const date = localTime ? new Date(timeStr) : timeStr.substring(0, timeStr.length - 1)
  return moment(date).format(format).toString()
}

export const formatSnakeCaseToSpaceCase = (myStr) =>
  myStr
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

export const emailTimeDisplay = (dbDate) => {
  const d = moment(dbDate)
  const currentDate = moment()
  if (currentDate.isSame(dbDate, 'day')) return d.format('h:mm a')
  if (currentDate.isSame(d, 'year')) return d.format('MMM DD')
  return d.format('MM/DD/YYYY')
}
